const initFormSelection = () => {
    //Todo: to improve this code make it more sustainable by removing all the ID selector and 
    // by iteranting among the dinamcally created elements in order to make it work also if there is more or less forms
    const contactForm = document.querySelector(".contact-form-section");
    //arrays
    const buttonsSelectorFormArray = document.querySelectorAll(".selector-form-button");
    const formsArray = document.querySelectorAll(".contact-form");
    const titleArray = document.querySelectorAll(".contact-form-section .wrapper .top-text");
    // radio buttons
    const contactUsFormButton = document.getElementById("contact-us-button");
    const reportUsFormButton = document.getElementById("report-us-button");
    const workWithUsFormButton = document.getElementById("work-with-us-button");
    // anchor buttons
    const contactUsFormAnchorButton = document.getElementById("contact-us-anchor-button");
    const reportUsFormAnchorButton = document.getElementById("report-us-anchor-button");
    const workWithUsFormAnchorButton = document.getElementById("work-with-us-anchor-button");
    //forms
    const contactUsForm = document.getElementById("contact-us");
    const reportUsForm = document.getElementById("report-us");
    const workWithUsForm = document.getElementById("work-with-us");
    //titles
    const contactUsTitle = document.getElementById("contact-us-title");
    const reportUsTitle = document.getElementById("report-us-title");
    const workWithUsTitle = document.getElementById("work-with-us-title");
    //functions
    contactUsFormButton.parentElement.classList.add("radio-active");
    const showElement = (Element) => {
        Element.classList.remove("not-visible");
        Element.classList.add("is-visible");
    };
    const hideAllElements = (arrayElements) => {
        arrayElements.forEach(function (singleForm) {
            singleForm.classList.remove("is-visible");
            singleForm.classList.add("not-visible");
        });
    };
    //query string on load
    if (window.location.hash) {
        hideAllElements(formsArray);
        hideAllElements(titleArray);
        if (window.location.hash === "#contact-us") {
            showElement(contactUsTitle);
            showElement(contactUsForm);
            contactUsFormButton.click();
            reportUsFormButton.parentElement.classList.remove("radio-active");
            workWithUsFormButton.parentElement.classList.remove("radio-active");
            contactUsFormButton.parentElement.classList.add("radio-active");
        }
        else if (window.location.hash === "#report-us") {
            showElement(reportUsTitle);
            showElement(reportUsForm);
            reportUsFormButton.click();
            contactUsFormButton.parentElement.classList.remove("radio-active");
            workWithUsFormButton.parentElement.classList.remove("radio-active");
            reportUsFormButton.parentElement.classList.add("radio-active");
        }
        else if (window.location.hash === "#work-with-us") {
            showElement(workWithUsTitle);
            showElement(workWithUsForm);
            workWithUsFormButton.click();
            contactUsFormButton.parentElement.classList.remove("radio-active");
            reportUsFormButton.parentElement.classList.remove("radio-active");
            workWithUsFormButton.parentElement.classList.add("radio-active");
        }
    }
    // For each button that is able to select a form add a click event
    // #contact-us, #report-us, #work-with-us
    // after click show the form that correspond to the selected radio button and click the corresponding radio button
    buttonsSelectorFormArray.forEach(function (singleButton) {
        singleButton.addEventListener('click', function (e) {
            /*e.preventDefault();*/
            hideAllElements(formsArray);
            hideAllElements(titleArray);
            //query string
            if (singleButton.hash === "#contact-us") {
                showElement(contactUsTitle);
                showElement(contactUsForm);
                contactUsFormButton.click();
                reportUsFormButton.parentElement.classList.remove("radio-active");
                workWithUsFormButton.parentElement.classList.remove("radio-active");
                contactUsFormButton.parentElement.classList.add("radio-active");
            }
            else if (singleButton.hash === "#report-us") {
                showElement(reportUsTitle);
                showElement(reportUsForm);
                reportUsFormButton.click();
                contactUsFormButton.parentElement.classList.remove("radio-active");
                workWithUsFormButton.parentElement.classList.remove("radio-active");
                reportUsFormButton.parentElement.classList.add("radio-active");
            }
            else if (singleButton.hash === "#work-with-us") {
                showElement(workWithUsTitle);
                showElement(workWithUsForm);
                workWithUsFormButton.click();
                contactUsFormButton.parentElement.classList.remove("radio-active");
                reportUsFormButton.parentElement.classList.remove("radio-active");
                workWithUsFormButton.parentElement.classList.add("radio-active");
            }
            //btn
            if (singleButton === contactUsFormButton || contactUsFormAnchorButton) {
                showElement(contactUsTitle);
                showElement(contactUsForm);
                contactUsFormButton.click();
                reportUsFormButton.parentElement.classList.remove("radio-active");
                workWithUsFormButton.parentElement.classList.remove("radio-active");
                contactUsFormButton.parentElement.classList.add("radio-active");
            }
            else if (singleButton === reportUsFormButton || reportUsFormAnchorButton) {
                showElement(reportUsTitle);
                showElement(reportUsForm);
                reportUsFormButton.click();
                contactUsFormButton.parentElement.classList.remove("radio-active");
                workWithUsFormButton.parentElement.classList.remove("radio-active");
                reportUsFormButton.parentElement.classList.add("radio-active");
            }
            else if (singleButton === workWithUsFormButton || workWithUsFormAnchorButton) {
                showElement(workWithUsTitle);
                showElement(workWithUsForm);
                workWithUsFormButton.click();
                contactUsFormButton.parentElement.classList.remove("radio-active");
                reportUsFormButton.parentElement.classList.remove("radio-active");
                workWithUsFormButton.parentElement.classList.add("radio-active");
            }
            contactForm.scrollIntoView();
        });
    });
};
